import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25L25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 25V0C11.193 0 0 11.193 0 25h25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m21.739 14.63-3.053 1.437 1.625 2.957-3.315-.634-.42 3.349-2.31-2.463-2.309 2.463-.42-3.35-3.315.635 1.626-2.957-3.053-1.436 3.053-1.436-1.626-2.957 3.315.634.42-3.35 2.31 2.464 2.309-2.463.42 3.349 3.316-.634-1.626 2.957 3.053 1.436Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M14.268 19.284a4.654 4.654 0 1 0 0-9.307 4.654 4.654 0 0 0 0 9.307Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M14.267 17.11a2.482 2.482 0 0 1-2.48-2.48 2.483 2.483 0 0 1 2.48-2.48 2.483 2.483 0 0 1 2.48 2.48 2.483 2.483 0 0 1-2.48 2.48Z"
}));
FlagTW.displayName = 'FlagTW';
export default withFlagWrapper(FlagTW);
//# sourceMappingURL=index.js.map